let runtimeConfig = {
	apiBaseUrl: "http://localhost:8003/",
	isLoaded: false,
};

export async function loadConfig() {
	if (runtimeConfig.isLoaded === false) {
		const response = await fetch("/config.json");
		runtimeConfig = await response.json();
	}
	return runtimeConfig;
}
 
export function setToken(userToken) {
	localStorage.setItem("token", JSON.stringify(userToken));
}

export function getToken() {
	const tokenString = localStorage.getItem("token");
	const userToken = JSON.parse(tokenString);
	return userToken?.token;
}

const listeners = {};

export function subscribe(event, callback) {
	if (!listeners[event]) {
		listeners[event] = [];
	}
	listeners[event].push(callback);
}

export function emit(event, data) {
	if (listeners[event]) {
		listeners[event].forEach((callback) => callback(data));
	}
}

export function sleep(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

export function toPersian10DigitDate(dateInput) {
    if (!dateInput) return "";
    const date = new Date(dateInput);
    // Format: 1403/04/16
    return date.toLocaleDateString("fa-IR-u-nu-latn", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    });
}